var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"god-damn-container"},[_c('p',{staticClass:"message"},[_vm._v("Поверните экран горизонтально!")])])}]

export { render, staticRenderFns }